import { betPanelHelper } from "app/helpers/betPanelHelper";
import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { get } from "lodash";
import { Middleware } from "redux";
/**
 * Middleware function for handling bet builder actions.
 *
 * This middleware listens for actions of type "betSlipListModel/addBetSlip" and
 * checks if betslip market allows bet builder and if there is no
 * processing bet. If these conditions are met, it dispatches an action to add a
 * bet builder item.
 *
 * @param {Store} store - The Redux store.
 * @param {Dispatch} next - The next middleware in the chain.
 * @param {unknown} action - The action being processed.
 * @returns {unknown} The result of the next middleware.
 */
export const betBuilderMiddleware: Middleware =
  store => next => (action: unknown) => {
    const result = next(action);

    if (
      typeof action === "object" &&
      action &&
      "type" in action &&
      "payload" in action
    ) {
      if (action.type === "betSlipListModel/addBetSlip") {
        const marketAllowedBetBuilder = get(action.payload, [
          "markets",
          0,
          "allowedBetBuilder",
        ]);
        const processingBet = get(action.payload, ["processingBet"]);
        const userAllowedBetBuilder = get(store.getState(), [
          "userModel",
          "user",
          "betBuilderBetAllowed",
        ]);
        betPanelHelper.countExpandedCollapsedBetSlips();
        if (
          marketAllowedBetBuilder &&
          !processingBet &&
          userAllowedBetBuilder
        ) {
          store.dispatch({
            type: "betBuilderModel/addBetBuilderItem",
            payload: action.payload,
          });
        }
      }
    }

    return result;
  };

// Validate bet builder after adding or removing a bet builder item
export const validateBetBuilderMiddleware: Middleware =
  store => next => action => {
    const result = next(action);

    if (
      typeof action === "object" &&
      action &&
      "type" in action &&
      "payload" in action &&
      (action.type === "betBuilderModel/addBetBuilderItem" ||
        action.type === "betBuilderModel/removeBetBuilderItem")
    ) {
      const eventId = (action as { type: string; payload: { id: string } })
        .payload.id;
      betPanelHelper.countExpandedCollapsedBetSlips();
      setTimeout(() => {
        store.dispatch({
          type: "betBuilderModel/validate",
          payload: { eventId },
        });
      }, 0);
    }

    return result;
  };

// update local storage with the current bet slip models
export const updateLocalStorageBetSlipsMiddleware: Middleware =
  store => next => action => {
    const result = next(action);

    if (
      typeof action === "object" &&
      action &&
      "type" in action &&
      "payload" in action &&
      (action.type === "betSlipListModel/removeBetSlip" ||
        action.type === "betSlipListModel/purgeBetSlipList" ||
        action.type === "betBuilderModel/removeBetBuilderItem" ||
        action.type === "betBuilderModel/removeBet" ||
        action.type === "betBuilderModel/removeAll")
    ) {
      const betSlipListModel = get(store.getState(), ["betSlipListModel"]);
      const multiplesBetSlipListModel = get(store.getState(), [
        "multiplesBetSlipListModel",
      ]);
      betPanelHelper.countExpandedCollapsedBetSlips();
      const betBuilderModel = get(store.getState(), ["betBuilderModel"]);
      BetSlipHelper.setLocalStorageBetSlipLists(
        betSlipListModel,
        multiplesBetSlipListModel,
        betBuilderModel
      );
    }

    return result;
  };
